module.exports = __webpack_public_path__ + "arr_r.60f68ea2.png";